import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBoltLightning, faDroplet} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import {useMediaQuery} from "react-responsive";

const PowerTrainType = ({powertrain, index}) => {
    
    const {t} = useTranslation();
    const isMobile = useMediaQuery({query: '(max-width: 799px)'})
    const isMinWidth = useMediaQuery({ query: '(min-width: 899px)' });
    const isMaxHeight = useMediaQuery({ query: '(max-height: 769px)' });
    
    if (!powertrain || powertrain.toLowerCase().includes("none")) return null;

    const vehicleType = powertrain.toUpperCase();
    const isPHEV = vehicleType.includes("PHEV");
    const isHEV =
        !isPHEV && ["MHEV", "HEV"].some(type => vehicleType.includes(type));
    const isBEV = vehicleType.includes("BEV");
    const isFCEV = vehicleType.includes("FCEV");
    const shouldTranslate = [0, 1, 2, 3].includes(index);

    const setAppNavbarZ = (z) => {
        const el = document.querySelector(".appNavbar");
        if (el) el.style.zIndex = String(z);
    };

    const handleShow = () => {
        if (shouldTranslate) setAppNavbarZ(1);
    };

    const handleHide = () => {
        if (shouldTranslate) setAppNavbarZ(10);
    };

    const renderIcon = (icon, tooltipKey) => (
        <div
            className="type-icons"
            onMouseEnter={handleShow}
            onMouseLeave={handleHide}
            onFocus={handleShow}
            onBlur={handleHide}
        >
            { ((isMinWidth && !isMaxHeight) || isMobile) && <div className="icon-wrapper">
                <FontAwesomeIcon icon={icon}/>
            </div>}
            {!isMobile && (
                <div className="tooltip-show">
                    {t(tooltipKey)}
                </div>
            )}
        </div>
    );

    if (isHEV) {
        return (
            <>
                {renderIcon(faDroplet, "vehicleType.HEV")}
                {renderIcon(faBoltLightning, "vehicleType.HEV")}
            </>
        );
    }

    if (isPHEV) {
        return (
            <>
                {renderIcon(faDroplet, "vehicleType.PHEV")}
                {renderIcon(faBoltLightning, "vehicleType.PHEV")}
            </>
        );
    }

    if (isBEV) {
        return renderIcon(faBoltLightning, "vehicleType.BEV");
    }

    if (isFCEV) {
        return renderIcon(faBoltLightning, "vehicleType.FCEV");
    }

    return null;
};

export default PowerTrainType